/**
 * Referall
 */
export const Referall = (function () {

  var init =  function () {   
          
    Referall.accept(); 
  }

  var accept = function() {
    var elements = document.getElementsByClassName("myds-accept-button");
    var acceptReferral = function() {
        // Get the name and id passed into the component
        var name = this.getAttribute('data-name');
        var id = this.getAttribute('data-id');
        // Get the status image element and set the active image
        var status = document.getElementById(`myds-status-image-${name}-${id}`);
        status.setAttribute('src','/static/images/tick-green.svg');
        // Get the status value element and set the html
        var status_value = document.getElementById(`myds-status-value-${name}-${id}`);
        status_value.innerHTML = 'ACCEPTED';
        // Show alert
        $(`#myds-alert-${name}-${id}`).fadeIn(500);
        // Remove button
        this.style.display = "none";
    };
    // Create the event listener
    for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', acceptReferral, false);
    }
  }

  return {
    init: init,
    accept:accept
  }

}());


